<template>
  <div class="page-6">
    <div class="course-header">
      <h2>免费使用脚本教程</h2>
      <p class="subtitle"><span class="highlight">包含DNF手游免费脚本</span></p>
      <div class="qq-groups">
        <span>飞天云用户Q群：<strong>1094848370</strong></span>
        <span>蜗牛助手用户Q群：<strong>1058029667</strong></span>
      </div>
    </div>

    <div class="course-body">
      <div class="step">
        <div class="step-label">第一步</div>
        <p>
          点击网址
          <a href="/home" class="link-purple">www.ftyunos.com</a>
          在浏览器中打开，或者
          <a href="#" class="link-purple" @click.prevent="download()">点击下载</a>
          飞天云手机
        </p>
      </div>

      <div class="step">
        <div class="step-label">第二步</div>
        <p>在网站上下载 APP</p>
        <div class="img-wrap">
          <img src="@/assets/img/云手机免费用蜗牛教程/image001.jpg" alt="步骤2" />
        </div>
      </div>

      <div class="step">
        <div class="step-label">第三步</div>
        <p>注册一个账号（新注册用户免费试用）</p>
        <div class="img-wrap">
          <img src="@/assets/img/云手机免费用蜗牛教程/image002.jpg" alt="步骤3" />
        </div>
      </div>

      <div class="step">
        <div class="step-label">第四步</div>
        <p>到云手机应用市场里下载蜗牛助手</p>
        <div class="img-wrap">
          <img src="@/assets/img/云手机免费用蜗牛教程/image003.jpg" alt="步骤4" />
        </div>
      </div>

      <div class="step">
        <div class="step-label">第五步</div>
        <p>
          在飞天云手机（<a href="#" class="link-purple" @click.prevent="download()">点击下载</a>）内打开蜗牛助手是免费用的
        </p>
        <div class="img-wrap">
          <img src="@/assets/img/云手机免费用蜗牛教程/image004.jpg" alt="步骤5" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { request } from "@/network/request-download";
export default {
  name: "course",
  methods: {
    download() {
      request({ url: `api/webSite/record/1/百度广告`, method: "get" }).then(() => {
        request({ url: `api/version/android/newApk/飞天云`, method: "get" }).then((res) => {
          if (res.code == 200) window.open(res.data);
        });
      });
    },
  },
};
</script>

<style scoped>
.page-6 {
  width: 100%;
  min-height: 100vh;
  background: #f8f9ff;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px 24px 80px;
  box-sizing: border-box;
}

.course-header {
  text-align: center;
  margin-bottom: 48px;
  max-width: 680px;
}
.course-header h2 {
  font-size: 2rem;
  font-weight: 700;
  color: #1a1a2e;
  margin: 0 0 12px;
}
.subtitle {
  margin: 0 0 16px;
}
.highlight {
  color: #e53935;
  font-size: 1.1rem;
  font-weight: 600;
}
.qq-groups {
  display: flex;
  gap: 24px;
  justify-content: center;
  flex-wrap: wrap;
  color: #444;
  font-size: 0.95rem;
}
.qq-groups strong {
  color: #7327ec;
}

.course-body {
  width: 100%;
  max-width: 680px;
  display: flex;
  flex-direction: column;
  gap: 40px;
}

.step {
  background: #fff;
  border-radius: 14px;
  padding: 28px 32px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
}
.step-label {
  display: inline-block;
  background: linear-gradient(90deg, #7327ec, #a75fe4);
  color: #fff;
  font-size: 0.85rem;
  font-weight: 600;
  padding: 4px 14px;
  border-radius: 20px;
  margin-bottom: 14px;
  letter-spacing: 1px;
}
.step p {
  font-size: 1rem;
  color: #333;
  line-height: 1.8;
  margin: 0 0 16px;
}
.step p:last-child {
  margin-bottom: 0;
}

.link-purple {
  color: #7327ec;
  text-decoration: none;
  font-weight: 600;
  transition: opacity 0.2s;
}
.link-purple:hover {
  opacity: 0.75;
  text-decoration: underline;
}

.img-wrap {
  text-align: center;
  margin-top: 16px;
}
.img-wrap img {
  max-width: 100%;
  height: auto;
  border-radius: 10px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

@media screen and (max-width: 768px) {
  .page-6 {
    padding: 40px 16px 60px;
  }
  .course-header h2 {
    font-size: 1.5rem;
  }
  .step {
    padding: 20px 18px;
  }
  .step p {
    font-size: 0.92rem;
  }
  .qq-groups {
    flex-direction: column;
    gap: 8px;
    align-items: center;
  }
}
</style>
